import { useState, useRef } from 'react';
import { colors } from 'ui/theme';
import { Phone } from 'ui/icons';
import { getInAppPosition } from 'modules/templatePreview/utils';
// import { InAppDisplaySettings, InboxMetadata } from 'modules/templatePreview/types';
import { INBOX_VIEW, IN_APP_VIEW, CARD } from 'modules/templatePreview/constants';

import {
  Container,
  Iframe,
  InboxContainer,
  InboxContent,
  InboxContentIcon,
  InboxContentSubtitle,
  InboxContentTitle,
  InboxHeader,
} from './InAppIframe.styled';

// type Props = {
//   inboxMetadata?: InboxMetadata,
//   inAppDisplaySettings?: InAppDisplaySettings,
//   inAppView?: IN_APP_VIEW | INBOX_VIEW,
//   previewHtml: string,
//   size?: CARD | THUMBNAIL,
// };

export const InAppIframe = ({
  inboxMetadata = {},
  inAppDisplaySettings = {},
  inAppView = IN_APP_VIEW,
  previewHtml = '',
  size = CARD,
}) => {
  /*
    The only way to get access to how large the content
    inside of an iframe is requires the use of javascript.

    We need the height to correctly position the content in the preview. 
  */

  const iframeRef = useRef(null);
  const [height, setHeight] = useState(0);

  const position = getInAppPosition(inAppDisplaySettings);
  const handleLoad = () => {
    if (position === 'full') {
      // this is how large the preview container is...
      // before we scale it down. a "full"y placed in-app
      // message takes up the entire viewport.
      return setHeight(525);
    }

    // if it's not fully placed, then we need to get the height
    // so that we can math out how to correctly position the contnet
    const iframeItem = iframeRef.current;
    const { scrollHeight } = iframeItem?.contentWindow?.document?.body;
    return setHeight(scrollHeight);
  };

  const showInAppInbox = inAppView === INBOX_VIEW;
  const { alpha, hex } = inAppDisplaySettings?.bgColor || {};
  const backgroundColor = showInAppInbox ? colors.grey5 : hex;
  const backgroundOpacity = showInAppInbox ? 1 : alpha;

  return (
    <Container showInAppInbox={showInAppInbox} size={size}>
      <Phone height={650} opacity={backgroundOpacity} color={backgroundColor} />
      {showInAppInbox && (
        <InboxContainer data-test="template-preview-in-app-inbox-container">
          <InboxHeader>Inbox</InboxHeader>
          <InboxContent>
            <div>
              <InboxContentTitle>{inboxMetadata.title}</InboxContentTitle>
              <InboxContentSubtitle>{inboxMetadata.subtitle}</InboxContentSubtitle>
            </div>
            {!!inboxMetadata.icon && <InboxContentIcon src={inboxMetadata.icon} alt="inbox icon" />}
          </InboxContent>
        </InboxContainer>
      )}
      {!showInAppInbox && (
        <Iframe
          className={position}
          tabIndex="-1" // don't want content inside the iframe to be focusable
          data-test="template-preview-in-app-iframe"
          scrolling="no"
          srcDoc={previewHtml}
          onLoad={handleLoad}
          height={height}
          ref={iframeRef}
          sandbox="allow-same-origin" // without this, we can't access the iframe's indards via JS.
        />
      )}
    </Container>
  );
};
